import { SearchableSelectOption } from '@/components/form-builder/form-builder.types';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable, of } from 'rxjs';
import { Select } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'sm-dac-prix-form',
  standalone: true,
  imports: [ButtonModule, CommonModule, FormsModule, TranslateModule, Select, AutoCompleteModule, MultiSelectModule],
  templateUrl: './dac-shortlist-form.component.html',
  styleUrl: './dac-shortlist-form.component.scss',
})
export class DacShortlistFormComponent implements OnInit {
  @Input() value: Observable<(number | number[])[]> = of([]);
  @Input() onChange?: (event: (number | number[])[]) => void;
  @Input() errors: Observable<string[]> = of([]);
  @Input() disabled = of(false);
  @Input() globalError: Observable<string> = of('');
  @Input() options: Observable<SearchableSelectOption[]> = of([]);
  @Input() etapeDac: Observable<string> = of('');
  @Input() displayAsList = false;

  selectedValues: (number | number[])[] = [];
  allOptions: SearchableSelectOption[] = [];
  suggestions: SearchableSelectOption[] = [];
  searchControlValue = '';

  uid = new Date().getTime();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.value.subscribe(values => {
      this.selectedValues = [...(values || [])];
      this.cdr.markForCheck();
    });

    this.options.subscribe(opts => {
      this.allOptions = opts || [];
      this.suggestions = this.getSuggestions();
      this.cdr.markForCheck();
    });
  }

  /** filter suggestions when typing */
  search(event: any) {
    const query = event.query.toLowerCase();
    this.suggestions = this.getSuggestions().filter(opt => opt?.searchable?.toLowerCase().includes(query));
  }

  /** exclude already selected options */
  getSuggestions(): SearchableSelectOption[] {
    const flatSelected = this.selectedValues.flat();
    return this.allOptions.filter(opt => !flatSelected.includes(opt.code as number));
  }

  /** add new row when selecting from autocomplete */
  onSearchSelect(event: any) {
    const value = event.value.code as number;
    this.selectedValues.push(value);
    this.searchControlValue = ''; // reset input
    this.suggestions = this.getSuggestions(); // refresh list
    this.emit();
  }

  addRow() {
    this.selectedValues.push(null as any);
    this.emit();
  }

  updateValue(index: number, value: any) {
    this.selectedValues[index] = value;
    this.suggestions = this.getSuggestions();
    this.emit();
  }

  removeRow(index: number) {
    this.selectedValues.splice(index, 1);
    this.suggestions = this.getSuggestions();
    this.emit();
  }

  clearAll() {
    this.selectedValues = [];
    this.suggestions = this.getSuggestions();
    this.emit();
  }

  emit() {
    this.onChange?.([...this.selectedValues]);
  }

  hasRemainingOptions(): boolean {
    const flatSelected = this.selectedValues.flat();
    return flatSelected.length < this.allOptions.length;
  }

  trackByFn(index: number) {
    return index;
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }

  getOptionName(code: number): string {
    return this.allOptions.find(opt => opt.code === code)?.name || '';
  }
}
